import { IOpChangeState } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { Utils } from '../util/utils'
import { OpDeviceType } from './op-device-type'
import { OpOperator } from './op-operator'
import { ConvertHelper } from '../../helpers'

export class OpDeviceTypeProfileMap implements IOpChangeState {
    public idDeviceTypeProfileMap: number
    public idDeviceType: number
    public idOperatorCreated: number
    public createdTime: Date
    public idOperatorModified: number
    public modifiedTime: Date

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#region Navigation properties

    public deviceType: OpDeviceType
    public operatorCreated: OpOperator
    public operatorModified: OpOperator

    //#endregion   

    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idDeviceTypeProfileMap = opObj.ID_DEVICE_TYPE_PROFILE_MAP
            this.idDeviceType = opObj.ID_DEVICE_TYPE
            this.idOperatorCreated = opObj.ID_OPERATOR_CREATED
            this.idOperatorModified = opObj.ID_OPERATOR_MODIFIED
            this.createdTime = opObj.CREATED_TIME != null ? ConvertHelper.stringToDate(opObj.CREATED_TIME) : null
            this.modifiedTime = opObj.MODIFIED_TIME != null ? ConvertHelper.stringToDate(opObj.MODIFIED_TIME) : null

            if (opObj._DeviceType != null) {
                this.deviceType = new OpDeviceType(opObj._DeviceType)
            }

            if (opObj._OperatorCreated != null) {
                this.operatorCreated = new OpOperator(opObj._OperatorCreated)
            }

            if (opObj._OperatorModified != null) {
                this.operatorModified = new OpOperator(opObj._OperatorModified)
            }

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_DEVICE_TYPE_PROFILE_MAP: this.idDeviceTypeProfileMap,
            ID_DEVICE_TYPE: this.idDeviceType,
            ID_OPERATOR_CREATED: this.idOperatorCreated,
            ID_OPERATOR_MODIFIED: this.idOperatorModified,
            CREATED_TIME: this.createdTime,
            MODIFIED_TIME: this.modifiedTime,

            _DeviceType: this.deviceType != null ? this.deviceType.toJSON() : null,
            _OperatorCreated: this.operatorCreated != null ? this.operatorCreated.toJSON() : null,
            _OperatorModified: this.operatorModified != null ? this.operatorModified.toJSON() : null,

            OpState: this.opState,
        }
    }

    public toString(): string {
        if (this.deviceType != null) {
            return this.deviceType.toString()
        }

        return "DeviceTypeProfileMap [" + this.idDeviceTypeProfileMap + "]";
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDeviceType[]): JQueryPromise<OpDeviceType[]> {
        return Utils.loadDataListNavigationProperties(dataProvider, list)
    }
}